import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import kebabCase from 'lodash/kebabCase';
import Layout from 'components/Layout/Layout.component';
import SEO from 'components/SEO';
import Article from 'components/Article/Article.component';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary.component';
import SchemaViewer from 'components/APISpec/SchemaViewer.component';
import { cleanPageContent } from 'utils/htmlUtils'
import { location as locationPropTypes } from 'utils/propTypes';
import ToastRadix from 'components/Toast/Toast.component';


function QueryPipelinesPageTemplate({ data, location, path, pageContext }) {
  const pageData = data.asciidoc;
  const title = pageData?.frontmatter?.title ?? 'No Title';
  const slug = location.pathname;
  // const pageVersion = path.split('/')[2];
  const permalink = pageData?.frontmatter?.permalink ?? '';
  const docType = pageData?.frontmatter?.doctype ?? '';

  const matched = path.split('*')[0];
  const rewrittenUrl = `${matched}${kebabCase(title)}`;
  
  useEffect(() => {
    window.history.replaceState(
      {},
      document.title,
      `${rewrittenUrl}${location.search}${location.hash}`,
    );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const params = new URLSearchParams(location.search);
  const q = params.get("q"); 
  const refq = params.get("refq"); 

  return (
    <Layout pathname={slug} q={q} title={title}>
      {pageData && (
        <>
          <Article article={pageData} docType={docType} q={q}/>
          <ErrorBoundary message="schema-viewer">
            {/* <SchemaViewer config={pageContext.dataConfig[`${pageData.frontmatter.stage_name}`]} /> */}
            <SchemaViewer config={pageContext.dataConfig} />
          </ErrorBoundary>
        </>
      )}
      {refq ? <ToastRadix query={refq} matched={matched} permalink={permalink} docType={docType}/> : null}
    </Layout>
  );
}

QueryPipelinesPageTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
  location: locationPropTypes.isRequired,
  pageContext: PropTypes.object.isRequired
};

export default QueryPipelinesPageTemplate;

/* eslint-disable react/prop-types */
export function Head({
  data,
  pageContext,
  location
}){

  const attributeFromPath = location.pathname.split('/')

  const pageData = data.asciidoc;
  const title = pageData?.frontmatter?.title ?? 'No Title';
  const subtitle = pageData?.frontmatter?.subtitle ?? null;
  const pageVersion = pageContext.canonical.split('/')[1];
  const permalink = pageData?.frontmatter?.permalink ?? '';
  const product = pageData?.frontmatter?.product ?? attributeFromPath[1];
  const objective = pageData?.frontmatter?.objective ?? '';
  const persona = pageData?.frontmatter?.persona ?? '';
  const docType = pageData?.frontmatter?.doctype ?? '';
  const matched = `/${pageContext.canonical}`

  const descriptionText = cleanPageContent(pageData.html)

  return (
    <SEO
      title={title}
      subtitle={subtitle}
      description={`${descriptionText.substring(0, 157)}...`}
      slug={matched}
      permalink={permalink}
      product={product}
      productVersion={pageVersion}
      objective={objective}
      persona={persona}
      docType={docType}
    />
  )
}
/* eslint-enable react/prop-types */

export const pageQuery = graphql`
  query QueryPipelinesPageByPath($filePath: String!) {
    asciidoc(paths: { from: { source: { file: { eq: $filePath } } } }) {
      html
      frontmatter {
        title
        subtitle
        permalink
        product
        layout
        stage_name
        persona
        objective
        doctype
      }
    }
  }
`;
